// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const CheckmarkIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="CheckmarkIcon" ref={forwardedRef} {...props}>
      <path d="M17.88 5.56 7.802 15.638 2.5 10.334l1.06-1.061 4.243 4.243L16.82 4.5z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const CheckmarkIcon = /* @__PURE__ */ Object.assign(
  CheckmarkIconComponent,
  { displayName: 'CheckmarkIcon' },
);
